// extracted by mini-css-extract-plugin
export default {"ctaSection":"CallToAction_ctaSection__CiFZP","ctaButton":"CallToAction_ctaButton__DgRfx"};